// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1oAgG","header":"MergedInvoice_header__1v6Hf"};